// console.log('tiny-slider.js');
import { tns } from 'tiny-slider/src/tiny-slider';
const lemjiCards = document.querySelectorAll('.home .post-type-list__grid.post');

if (lemjiCards.length > 0) {
    lemjiCards.forEach((lemjiCard) => {

      const slider = tns({
        container: lemjiCard,
        items: 1,
        slideBy: '1',
        autoplay: false,
        controls: true,
        controlsText: [
            '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M19.335 12L5.33496 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.335 18L5.33496 12L11.335 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M5.33496 12H19.335" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.335 6L19.335 12L13.335 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        nav: false,
        loop: false,
        swipeAngle: false,
        gutter: 20,
        responsive: {
            0: {
              items: 1,
              gutter: 10,
              fixedWidth: false
            },
            599: {
              items: 2,
              gutter: 10,
              fixedWidth: false
            },
            781: {
              items: 3,
              gutter: 15,
              fixedWidth: false
            },
            959: {
              items: 3,
              gutter: 20,
            }
          },
      });
      slider.events.on('transitionEnd', function(slider,event) {
        for (let $el of slider.slideItems) {
          $el.ariaHidden = false;
          $el.removeAttribute('tabindex');
      }
      });
    });
  }

const lemjiTestimonialCards = document.querySelectorAll('.testimonial-list__grid.testimonial');

if (lemjiTestimonialCards.length > 0) {
    lemjiTestimonialCards.forEach((lemjiTestimonialCard) => {

      const slider = tns({
        container: lemjiTestimonialCard,
        items: 1,
        slideBy: '1',
        autoplay: false,
        controls: true,
        controlsText: [
            '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M19.335 12L5.33496 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.335 18L5.33496 12L11.335 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M5.33496 12H19.335" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.335 6L19.335 12L13.335 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        nav: false,
        loop: false,
        swipeAngle: false,
        gutter: 20,
        responsive: {
            0: {
              items: 1,
              gutter: 10,
              fixedWidth: false
            },
            599: {
              items: 2,
              gutter: 10,
              fixedWidth: false
            },
            781: {
              items: 3,
              gutter: 15,
              fixedWidth: false
            },
            959: {
              items: 3,
              gutter: 20,
            }
          },
      });
      slider.events.on('transitionEnd', function(slider,event) {
        for (let $el of slider.slideItems) {
          $el.ariaHidden = false;
          $el.removeAttribute('tabindex');
      }
      });
    });
  }
